import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiX } from "react-icons/fi";
import { FOUNDER_BIRTHDAY } from "../../config/constants/founderBirthday";
import useFounderBirthday from "../../hooks/useFounderBirthday";

const DISMISS_KEY = "arvix:birthday-pill-dismissed";

const wasDismissed = () => {
    try {
        return sessionStorage.getItem(DISMISS_KEY) === "1";
    } catch {
        return false;
    }
};

// On 23 September, points visitors on every other page back to the
// homepage celebration. The homepage itself opens with it, so it's hidden
// there. Dismissing it keeps it away for the rest of the tab's visit.
const BirthdayPill = () => {
    const isFounderBirthday = useFounderBirthday();
    const { pathname } = useLocation();
    const [dismissed, setDismissed] = useState(wasDismissed);

    if (!isFounderBirthday || dismissed || pathname === "/") return null;

    const dismiss = () => {
        try {
            sessionStorage.setItem(DISMISS_KEY, "1");
        } catch {
            // Storage blocked; hiding it for this page view is enough.
        }
        setDismissed(true);
    };

    return (
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 w-[calc(100%-2rem)] max-w-md">
            <div className="flex items-center gap-2 rounded-full bg-designer-dark text-white shadow-xl pl-5 pr-1.5 py-1.5">
                <span aria-hidden="true" className="relative flex w-2 h-2 shrink-0">
                    <span className="absolute inset-0 rounded-full bg-designer-accent motion-safe:animate-ping opacity-70" />
                    <span className="relative w-2 h-2 rounded-full bg-designer-accent" />
                </span>
                <Link
                    to="/#birthday"
                    className="flex-1 text-sm leading-snug py-1.5 hover:underline underline-offset-2 focus:outline-none focus-visible:underline"
                >
                    It’s {FOUNDER_BIRTHDAY.firstName}’s birthday today. Blow out his candles.
                </Link>
                <button
                    type="button"
                    onClick={dismiss}
                    className="shrink-0 w-9 h-9 rounded-full flex items-center justify-center text-white/70 hover:text-white hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-designer-secondary"
                    aria-label="Dismiss birthday message"
                >
                    <FiX className="w-4 h-4" aria-hidden="true" />
                </button>
            </div>
        </div>
    );
};

export default BirthdayPill;
